import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink } from '@prismicio/react'

const Hero = ({ slice }) => {
  return (
    <section className='component-hero mx-auto max-w-screen-xl p-6'>
      <div className='relative overflow-hidden bg-white bg-cover bg-no-repeat'>
        <div className='container mx-auto flex-row md:flex'>
          <div className='content w-full flex-1 pt-20'>
            <div className='pb-8 text-center sm:pb-16 md:pb-20 lg:pb-28 lg:text-left xl:pb-32'>
              <div className='mx-auto mt-10 px-6 sm:mt-12 md:mt-16 lg:mt-20 xl:mt-28'>
                <div className='inline-block bg-gradient-to-r from-blue-600 to-blue-500 bg-clip-text text-5xl font-black tracking-tight text-transparent md:text-6xl' itemProp='name'>
                  <PrismicRichText field={slice.primary.title.richText} />
                </div>
                {slice.primary.text.richText && (
                  <div className='my-4 sm:mx-auto lg:mx-0' itemProp='headline'>
                    <PrismicRichText field={slice.primary.text.richText} />
                  </div>
                )}
                {slice.primary.button_link && slice.primary.button_text && (
                  <PrismicLink className='button mt-3' href={slice.primary.button_link.url}>
                    {slice.primary.button_text}
                  </PrismicLink>
                )}
              </div>
            </div>
          </div>
          {slice.primary.image.gatsbyImageData && (
            <div className='flex-1'>
              <div className='polygon top-0 right-0 bottom-0 md:absolute md:w-1/2'>
                <GatsbyImage image={slice.primary.image.gatsbyImageData} alt={slice.primary.image.alt} />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Hero
